import { render, staticRenderFns } from "./tilmelding.vue?vue&type=template&id=24d2e28e&"
import script from "./tilmelding.vue?vue&type=script&lang=js&"
export * from "./tilmelding.vue?vue&type=script&lang=js&"
import style0 from "./tilmelding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports